import { createSlice } from "@reduxjs/toolkit";
import { forgotPasswordSendOtp, forgotPasswordVerifyOtp, resetAccountPassword } from "../api/forgotPassword";

interface ForgotPasswordState {
    loading: boolean;
    currentRequestId: undefined | string;
    userData: any;
    error: any;
}

const initialState: ForgotPasswordState = {
    loading: false,
    currentRequestId: undefined,
    userData: null,
    error: null,
}

export const NotificationDataSlice = createSlice({
    name: 'forgotPasswordData',
    initialState,
    reducers: {
        resetForgotPasswordState: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase("RESET_ALL", (state, action) => {
                return initialState;
            })
            .addCase(forgotPasswordSendOtp.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(forgotPasswordSendOtp.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(forgotPasswordSendOtp.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
            .addCase(forgotPasswordVerifyOtp.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(forgotPasswordVerifyOtp.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(forgotPasswordVerifyOtp.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
            .addCase(resetAccountPassword.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(resetAccountPassword.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(resetAccountPassword.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
    }
})

export const { resetForgotPasswordState } = NotificationDataSlice.actions;

export default NotificationDataSlice.reducer;